import { connect } from 'react-redux'
import { state_update } from '../actions'
import AiToolbar from './AiToolbar'
import ReactGA from 'react-ga';
import {ADD_TO_CART_URL,MSG_NO_USER_DIAMOND, ADD_TO_CART_URL_PROD,MSG_NOT_READY_ADD_TO_CART1,MSG_NOT_READY_ADD_TO_CART2,DEFAULT_STATE_VALUE,MSG_NO_SESSION1,MSG_NO_SESSION2} from '../constants'; 
import {crosssku} from '../reducers/reducer.js'
import { scrollToOption } from './AiOptionSet';
import smoothscroll from 'smoothscroll-polyfill';
window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();

var optText = '';
var option = '';

const showMessage =(dispatch,data)=>{
  dispatch(state_update({attr:'message',value:data}))
}
const addToCartOptions =(state)=>{
  let skus = state.sku
  if ([1,2].includes(state.cross1))
      skus += ',' + crosssku[state.cross1-1]
  if ([1,2].includes(state.cross2))
      skus += ',' + crosssku[state.cross2+1]
  if ([1,2].includes(state.cross3))
      skus += ',' + crosssku[state.cross3+3]

  var all_addcart_options =[]
 let general_options =['action','hs','hu','sku','style','isposterminal','initzalessku','esaselected' ]
  for (let new_opt in general_options) {
     all_addcart_options.push(general_options[new_opt])
  }

  let res={}
  res['site']= window.currentSite
  res['env']= window.currentEnv

  if (state['cfg'] !== undefined){
    res['cfg']= state['cfg'].substring(9)
  }
  else 
    res['cfg']= ''
  let port = window.location.port
  //console.log('PORT',port)  
  
  if (port !== '80' && port !== '' ) {
    port = ':' + port
  }
  else {
    port =''
  }

  res['shopping_url']=window.location.hostname +port
  for (let j in all_addcart_options) {
      if (all_addcart_options[j] === 'sku') {
        res[all_addcart_options[j]] = skus
      }
      else {
        res[all_addcart_options[j]] = state[all_addcart_options[j]]
      }
    }

  return res
}
const checkSession =(state)=>{
  if (state['hs'] === DEFAULT_STATE_VALUE )
    return false
 // console.log('session true')  
  return true  
  
}

const checkOptions = (state)=>{
  if (state.type === 'R' && state.rs === '0') {
    optText = 'RING SIZE'
    option = 'rs'
    return false
  }
  if (state.type === 'B' && state.bl === '0' && state.sh !== 'B3') {
    optText = 'BRACELET LENGTH'
    option = 'bl'
    return false
  }
  if (state.type === 'R' && state.cross3 !== 0 && state.bl2 === '0' && state.cross3 !== 2) {
    optText = 'BRACELET LENGTH' //(MATCHING STYLE)'
    option = 'bl2'
    return false
  }
  if (state.type === 'P' && state.cross1 !== 0 && state.rs2 === '0') {
    optText = 'RING SIZE' //(MATCHING STYLE)'
    option = 'rs2'
    return false
  }
  if (state.type === 'P' && state.cross3 !== 0 && state.bl2 === '0' && state.cross3 !== 2) {
    optText = 'BRACELET LENGTH' //(MATCHING STYLE)'
    option = 'bl2'
    return false
  }
  if (state.type === 'E' && state.cross1 !== 0 && state.rs2 === '0') {
    optText = 'RING SIZE' //(MATCHING STYLE)'
    option = 'rs2'
    return false
  }
  if (state.type === 'E' && state.cross3 !== 0 && state.bl2 === '0' && state.cross3 !== 2) {
    optText = 'BRACELET LENGTH' //(MATCHING STYLE)'
    option = 'bl2'
    return false
  }
  if (state.type === 'B' && state.cross1 !== 0 && state.rs2 === '0') {
    optText = 'RING SIZE' //(MATCHING STYLE)'
    option = 'rs2'
    return false
  }
  optText = ''
  option = ''
  return true
}

const checkUserDiamond =(state)=>{
 
  return true
}

const addToCart =(dispatch,param,price)=>{
  //console.log('start add to cart',param)
  if (window.add2cart==='sent'  )
    return
  window.add2cart='sent'  

ReactGA.event({
  category: 'AddToCart',
  action:'AddToCart' 
});
  let header = new Headers({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'multipart/form-data'
  });
  let sentData = {
      method: 'POST', 
      mode: 'cors',
      header: header,
      body: JSON.stringify(param)
      
  };
  let fetchUrl =ADD_TO_CART_URL
  

  if (window.currentEnv ==='www' || window.currentEnv ==='prod2' ){
    fetchUrl =ADD_TO_CART_URL_PROD
  }
  //console.log('add to cart refresh',param)
          
  let sku =param.sku
  let skuPrice = price
  let nexusSite = window.currentSite
  let nexusSiteTitle = nexusSite.substring(0,1).toUpperCase() + nexusSite.slice(1)
  // 2000 for Kay, 2032 for KayOutlet, 2001 for Jared, 0008 for ZalesOutlet
  //let stext1 = 'window.adobeDataLayer.push({'+
/*   var dataLayer = new Object();dataLayer = {"cart": {"cartID": param.hc},
    "event":"cartItemAddition",
"product": {"productListItems":[{"baseProduct":"V-" + sku ,"brand":nexusSite,  "description":"","inventoryLevel":"","origPrice":skuPrice,"outOfStock":"","parentProduct":"","personalization":"",
"productCategory":"Custom Fashion","productClass":"","productName":"Fashion Customizer","productSKU": sku,"quantity":"1","rating": "","ratingCount":"","salePrice":skuPrice,"startingPrice":skuPrice,
"title":nexusSiteTitle	}]},
"user": {"asmLoggedIn":"false","city":"","country":"","email":"anonymous","guestID":"","lastLoginDate":"","loginMethod":"","loginSuccess":"","loyaltyID":"","loyaltyMember":"false","scid":"",
"sessionID":param.hu,"state":"","userId":"anonymous","userStatus":"G","zipcode":""}};
//console.log('push start',dataLayer)
try {
if (window.adobeDataLayer !== null)
window.adobeDataLayer.push(dataLayer);
//window.adobeDataLayer[0]=dataLayer;
//console.log('push done')
}
catch(e) {
  console.log('error in push',e)
  
} */
  showMessage(dispatch,{severity: 'info', summary: '', sticky: false, detail: 'Redirecting to Shopping Bag'})
  //window.testAB='A'
  ReactGA.event({
    category: 'test'+ window.testAB +'-add2cart',
    action:"addAB"
});
  fetch(fetchUrl+'/', sentData)
      .then(response => {
        window.add2cart='received'  
          if (response.ok) {
                return response.json();
              
          }
          else {
            showMessage(dispatch,{severity: 'error', summary: 'Error for Add to Cart: ', detail: 'No response'})
            
          }
      })
      .then(json => {

          if (Object.keys(json).length === 0 || json.url === '') {
            showMessage(dispatch,{severity: 'error', summary: 'Error for Add to Cart: ', detail: 'Error in shopping cart'})
          }
          //console.log('load json', json)]
          var json2;
          if (param['action'] === 'param') {  
            json2 = JSON.stringify(json);
            showMessage(dispatch,{severity: 'info', summary: 'Action: ' + param['action'], sticky: true, detail: json2})
            return
          } else if (param['action'] === 'request') {  
            json2 = JSON.stringify(json);
            showMessage(dispatch,{severity: 'info', summary: 'Action: ' + param['action'], sticky: true, detail: json2})
            return
        } else if (param['action'] === 'response') {  
          json2 = JSON.stringify(json);
          showMessage(dispatch,{severity: 'info', summary: 'Action: ' + param['action'], sticky: true, detail: json2})
          return
        } else {  //redirect
 //         console.log('redirect',json)
          if (json.code ===0) {
            window.location = json.url
          }
          else {  
            if (json.msg.includes('error.cart.limit'))
            showMessage(dispatch,{severity: 'info', summary: 'Our Shopping Bags will only hold 50 items at a time. If ordering over 50 items, please place a second order for the additional items. Thank you for your understanding.' , sticky: false, detail: json.url})
            else 
            showMessage(dispatch,{severity: 'info', summary: 'Action code is ' + json.code + ' ' + json.msg , sticky: false, detail: json.url})
            return  
          }
       
        }


          

          
      })
      .catch(errorMsg => {
          //error = true
          window.add2cart='received'  
          showMessage(dispatch,{severity: 'error',summary: 'Error for Add to Cart: ',detail: 'General Error'})
          
      //    console.log('error', errorMsg)
      });
  }
 
const mapStateToProps = (state, ownProps) => ({
  sku: state['sku'],
  cross1: state.cross1,
  cross2: state.cross2,
  cross3: state.cross3,
  initial: state.initial,
  readyForAddToCart: checkOptions(state),
 // cur_dc: state['dc'],
  readyForSession: checkSession(state),
  readyForUserDiamond: checkUserDiamond(state),
  urlParams: addToCartOptions(state),
  costcard:state['action']
})





const mapDispatchToProps = (dispatch, ownProps) => ({
  onRefreshReview: ( (attr,value) => dispatch(state_update({attr:attr,value:value}))),
  onNoOptionMessage: ( () => {
      let msgText = MSG_NOT_READY_ADD_TO_CART1 + optText + MSG_NOT_READY_ADD_TO_CART2;
      dispatch(state_update({attr: 'message', value: {severity: 'info', summary: 'Warning: ', detail: msgText}}));
      setTimeout(function(){scrollToOption(option)}, 50);
    }),
  onNoSessionMessage: ( () => dispatch(state_update({attr:'message',
    value:{severity: 'error',summary: 'Warning: ',detail: MSG_NO_SESSION1 + window.currentEnv + '.'+ window.currentSite+'.com' +MSG_NO_SESSION2}}))),
  onNoUserDiamond: ( (cur_dc) => {
    //console.log('active User Diamond');
  dispatch(state_update({attr:'message',value:{severity: 'error',summary: 'Warning: ',detail: MSG_NO_USER_DIAMOND}}))


}),
  onAddToCart: ( (param,price) => addToCart(dispatch,param,price)  )
})



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiToolbar)


// WEBPACK FOOTER //
// ./src/layout/AiToolbarWrap.js